var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 122,
    height: 122
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    rx: 61,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    rx: 61,
    fill: "#3B4559"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 150.5,
    r: 72.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 22.5,
    transform: "matrix(1 0 0 -1 61.5 44.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 114,
    height: 114,
    rx: 57,
    stroke: "#3B4559",
    strokeWidth: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioIcon);
export default __webpack_public_path__ + "static/media/Bio-Icon.9859ed210abe85b2a6f82518c87d1e74.svg";
export { ForwardRef as ReactComponent };